// extracted by mini-css-extract-plugin
export default {"stroke":"stroke__x5+XM","first":"first__DE8X6","second":"second__2dvP8","white":"white__2BxMg"};